"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _constants = require("../constants");

// Note that we have *not* made this function an async. This is because the function must be sync
// up until `structureData` is called
var legacyEvent = function legacyEvent(client, _ref) {
  var type = _ref.type,
      _ref$meta = _ref.meta,
      meta = _ref$meta === void 0 ? {} : _ref$meta,
      data = _ref.data;
  var eventConfig = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {
    force: false
  };
  var force = eventConfig.force;
  var _EVENTS$type = _constants.EVENTS[type],
      version = _EVENTS$type.version,
      cheggDbEventName = _EVENTS$type.cheggDbEventName; // Include the datetime if the caller has not:

  var eventTime = meta.eventTime || new Date();
  var metaInternal = {
    eventTime: eventTime,
    version: version
  };
  return client._nakedEvent({
    data: data || {},
    type: cheggDbEventName,
    meta: metaInternal
  }, {
    force: force
  });
};

var _default = legacyEvent;
exports["default"] = _default;